export default __webpack_public_path__ + "static/media/donuts-no-4.e88f84d4.ogg";